/**
 * 发票查询模块接口列表
 */
import Vue from "vue"
import axios from '@/utils/http'; // 导入http中创建的axios实例
const invoice = {
    //页面初始化
    init() {
      return axios.get(`${Vue.prototype.$base.API_PATH}/invoice/init`);
    },
    //得到发票数据集合
    list(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/invoice/s-grid`, { params: params});
    },
    //生成excel
    excel(params) {
      return axios.get(`${Vue.prototype.$base.API_PATH}/invoice/s-excel`, { params: params});
    },
}

export default invoice;



// WEBPACK FOOTER //
// ./src/api/invoice.js